export const RoleTransate =  (role: string): string =>{
    if (role === 'User') role =  'Nutzer'
    return role
}